import { styled } from '@/styles/stitches.config';

// This is largely a copy-paste from the languageDropdown component
export const Menu = styled('ul', {
  listStyleType: 'none',
  position: 'absolute',
  whiteSpace: 'nowrap',
  background: '$white',
  borderRadius: '$1',
  color: '$unicef',
  paddingBlock: '$2',
  paddingInline: '$3',
  boxShadow: '$1',
  margin: 0,
  variants: {
    direction: {
      up: {
        insetBlockEnd: 'calc(100% + $space$2)',
      },
      down: {
        insetBlockStart: 'calc(100% + $space$2)',
      },
    },
    alignment: {
      left: {
        insetInlineStart: 0,
      },
      right: {
        insetInlineEnd: 0,
      },
    },
  },
});

export const MenuItem = styled('li', {
  marginBlockEnd: '$1',
});
